class SlideEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

      // キャリア・研修制度
      const careerSwiper = document.querySelector(".model-step-swiper")

      if(careerSwiper){
        const careerStepSwiper = new Swiper(careerSwiper, {
          slidesPerView: "auto"/* この行を追加 */,
          spaceBetween: 30,
          // ページネーションが必要なら追加
          pagination: {
            el: ".swiper-pagination"
          },

          // ナビボタンが必要なら追加
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            769: {
              spaceBetween: 60,
            },

          },
        });
      }

  }
}
